export default "__VITE_ASSET__BzoJRPwo__"